/**
 * GENERATED by tools/gen-escape/gen.ts — do not edit by hand.
 * Escape boards (GDD §8.8), bucketed by the number of blocks besides the getaway car.
 * Each board is [moves, [[x, y, length, horizontal(1/0)], ...]] with the car first.
 */

export type LibraryBoard = readonly [
  moves: number,
  blocks: readonly (readonly [number, number, number, number])[],
];

export const ESCAPE_LIBRARY: Record<number, readonly LibraryBoard[]> = {
  3: [
    [
      1,
      [
        [2, 2, 2, 1],
        [0, 5, 3, 1],
        [1, 0, 3, 0],
        [2, 3, 3, 1],
      ],
    ],
    [
      1,
      [
        [2, 2, 2, 1],
        [1, 2, 2, 0],
        [1, 0, 2, 0],
        [0, 3, 2, 0],
      ],
    ],
    [
      2,
      [
        [2, 2, 2, 1],
        [0, 1, 2, 0],
        [4, 5, 2, 1],
        [5, 2, 2, 0],
      ],
    ],
    [
      2,
      [
        [0, 2, 2, 1],
        [3, 0, 2, 1],
        [2, 2, 3, 0],
        [0, 3, 3, 0],
      ],
    ],
    [
      3,
      [
        [1, 2, 2, 1],
        [3, 4, 2, 1],
        [2, 0, 2, 1],
        [3, 2, 2, 0],
      ],
    ],
    [
      3,
      [
        [1, 2, 2, 1],
        [4, 2, 2, 0],
        [1, 0, 2, 0],
        [3, 1, 2, 0],
      ],
    ],
    [
      4,
      [
        [0, 2, 2, 1],
        [2, 4, 2, 1],
        [2, 0, 3, 0],
        [2, 3, 3, 1],
      ],
    ],
    [
      4,
      [
        [0, 2, 2, 1],
        [4, 1, 2, 0],
        [5, 1, 2, 0],
        [2, 1, 2, 0],
      ],
    ],
    [
      5,
      [
        [0, 2, 2, 1],
        [3, 2, 3, 0],
        [1, 5, 3, 1],
        [0, 3, 3, 0],
      ],
    ],
    [
      5,
      [
        [2, 2, 2, 1],
        [3, 4, 3, 1],
        [5, 1, 3, 0],
        [2, 3, 2, 0],
      ],
    ],
  ],
  4: [
    [
      2,
      [
        [1, 2, 2, 1],
        [0, 4, 2, 1],
        [2, 5, 3, 1],
        [3, 1, 2, 0],
        [1, 0, 2, 0],
      ],
    ],
    [
      3,
      [
        [0, 2, 2, 1],
        [2, 1, 2, 0],
        [2, 0, 2, 1],
        [0, 0, 2, 0],
        [1, 3, 2, 1],
      ],
    ],
    [
      3,
      [
        [1, 2, 2, 1],
        [3, 3, 2, 1],
        [2, 0, 2, 1],
        [3, 1, 2, 0],
        [1, 5, 2, 1],
      ],
    ],
    [
      4,
      [
        [0, 2, 2, 1],
        [2, 4, 3, 1],
        [2, 5, 3, 1],
        [2, 1, 3, 0],
        [0, 1, 2, 1],
      ],
    ],
    [
      4,
      [
        [0, 2, 2, 1],
        [3, 2, 2, 0],
        [2, 2, 2, 0],
        [3, 4, 2, 1],
        [3, 1, 2, 1],
      ],
    ],
    [
      5,
      [
        [0, 2, 2, 1],
        [2, 1, 2, 0],
        [3, 4, 2, 1],
        [2, 3, 2, 1],
        [3, 0, 3, 0],
      ],
    ],
    [
      5,
      [
        [1, 2, 2, 1],
        [2, 4, 3, 1],
        [1, 3, 2, 0],
        [1, 1, 3, 1],
        [4, 1, 3, 0],
      ],
    ],
    [
      6,
      [
        [1, 2, 2, 1],
        [3, 1, 3, 0],
        [1, 4, 3, 1],
        [4, 3, 2, 1],
        [4, 0, 3, 0],
      ],
    ],
    [
      6,
      [
        [2, 2, 2, 1],
        [5, 1, 3, 0],
        [2, 3, 2, 1],
        [3, 4, 2, 0],
        [4, 4, 2, 1],
      ],
    ],
    [
      7,
      [
        [2, 2, 2, 1],
        [3, 3, 3, 0],
        [4, 3, 2, 1],
        [4, 0, 3, 0],
        [1, 0, 3, 1],
      ],
    ],
    [
      7,
      [
        [1, 2, 2, 1],
        [3, 2, 3, 0],
        [4, 4, 2, 1],
        [2, 3, 2, 0],
        [4, 1, 3, 0],
      ],
    ],
    [
      8,
      [
        [1, 2, 2, 1],
        [4, 0, 3, 0],
        [2, 3, 3, 0],
        [3, 1, 3, 0],
        [4, 3, 2, 1],
      ],
    ],
    [
      9,
      [
        [0, 2, 2, 1],
        [5, 1, 3, 0],
        [4, 4, 2, 1],
        [2, 3, 3, 1],
        [2, 0, 3, 0],
      ],
    ],
    [
      11,
      [
        [0, 2, 2, 1],
        [4, 2, 3, 0],
        [1, 3, 2, 0],
        [2, 4, 2, 1],
        [2, 1, 3, 0],
      ],
    ],
  ],
  5: [
    [
      3,
      [
        [0, 2, 2, 1],
        [2, 1, 2, 0],
        [2, 4, 2, 1],
        [1, 5, 2, 1],
        [4, 2, 2, 0],
        [1, 0, 2, 0],
      ],
    ],
    [
      3,
      [
        [0, 2, 2, 1],
        [3, 2, 2, 0],
        [1, 5, 2, 1],
        [2, 2, 2, 0],
        [0, 0, 2, 1],
        [1, 3, 2, 0],
      ],
    ],
    [
      4,
      [
        [0, 2, 2, 1],
        [2, 1, 3, 1],
        [1, 4, 2, 1],
        [2, 2, 2, 0],
        [0, 0, 2, 1],
        [5, 2, 3, 0],
      ],
    ],
    [
      4,
      [
        [1, 2, 2, 1],
        [0, 0, 3, 1],
        [3, 4, 2, 1],
        [1, 3, 3, 1],
        [4, 1, 2, 1],
        [3, 0, 3, 0],
      ],
    ],
    [
      5,
      [
        [0, 2, 2, 1],
        [3, 0, 3, 1],
        [1, 5, 2, 1],
        [3, 2, 2, 0],
        [2, 2, 3, 0],
        [4, 2, 2, 0],
      ],
    ],
    [
      5,
      [
        [1, 2, 2, 1],
        [1, 5, 3, 1],
        [0, 0, 3, 1],
        [3, 1, 3, 0],
        [2, 4, 2, 1],
        [4, 2, 2, 0],
      ],
    ],
    [
      6,
      [
        [0, 2, 2, 1],
        [5, 2, 2, 0],
        [3, 1, 2, 0],
        [2, 0, 3, 0],
        [1, 3, 2, 1],
        [1, 5, 2, 1],
      ],
    ],
    [
      6,
      [
        [0, 2, 2, 1],
        [4, 1, 2, 1],
        [3, 4, 2, 1],
        [2, 2, 3, 0],
        [4, 2, 2, 0],
        [3, 1, 2, 0],
      ],
    ],
    [
      7,
      [
        [2, 2, 2, 1],
        [2, 3, 2, 0],
        [3, 3, 3, 0],
        [0, 3, 3, 0],
        [4, 0, 3, 0],
        [4, 3, 2, 1],
      ],
    ],
    [
      7,
      [
        [0, 2, 2, 1],
        [2, 4, 2, 1],
        [5, 2, 2, 0],
        [0, 3, 3, 0],
        [3, 1, 3, 0],
        [1, 5, 3, 1],
      ],
    ],
    [
      11,
      [
        [1, 2, 2, 1],
        [4, 2, 3, 0],
        [1, 3, 2, 0],
        [0, 2, 2, 0],
        [2, 4, 2, 1],
        [3, 1, 3, 0],
      ],
    ],
    [
      12,
      [
        [1, 2, 2, 1],
        [1, 3, 2, 0],
        [3, 4, 2, 1],
        [5, 3, 2, 0],
        [3, 1, 3, 0],
        [5, 1, 2, 0],
      ],
    ],
    [
      12,
      [
        [1, 2, 2, 1],
        [3, 1, 3, 0],
        [4, 2, 3, 0],
        [1, 0, 2, 1],
        [2, 4, 2, 1],
        [1, 3, 2, 0],
      ],
    ],
    [
      13,
      [
        [1, 2, 2, 1],
        [2, 5, 3, 1],
        [1, 4, 2, 0],
        [3, 4, 2, 1],
        [5, 2, 3, 0],
        [3, 1, 3, 0],
      ],
    ],
  ],
  6: [
    [
      5,
      [
        [0, 2, 2, 1],
        [0, 3, 3, 0],
        [5, 2, 2, 0],
        [4, 1, 2, 1],
        [2, 2, 3, 0],
        [2, 5, 2, 1],
        [3, 1, 2, 0],
      ],
    ],
    [
      5,
      [
        [0, 2, 2, 1],
        [1, 4, 2, 1],
        [3, 1, 3, 1],
        [2, 5, 2, 1],
        [3, 2, 2, 0],
        [0, 1, 2, 1],
        [2, 1, 3, 0],
      ],
    ],
    [
      6,
      [
        [0, 2, 2, 1],
        [3, 1, 2, 0],
        [5, 2, 2, 0],
        [2, 1, 2, 0],
        [1, 0, 2, 1],
        [1, 4, 2, 1],
        [4, 1, 2, 0],
      ],
    ],
    [
      6,
      [
        [0, 2, 2, 1],
        [2, 1, 2, 0],
        [4, 0, 3, 0],
        [3, 4, 2, 0],
        [5, 1, 2, 0],
        [3, 1, 2, 0],
        [2, 3, 3, 1],
      ],
    ],
    [
      7,
      [
        [1, 2, 2, 1],
        [3, 4, 3, 1],
        [5, 1, 2, 0],
        [2, 3, 2, 0],
        [3, 1, 3, 0],
        [1, 0, 2, 0],
        [4, 2, 2, 0],
      ],
    ],
    [
      7,
      [
        [0, 2, 2, 1],
        [4, 0, 2, 1],
        [2, 4, 3, 1],
        [1, 3, 2, 1],
        [2, 0, 3, 0],
        [4, 3, 2, 1],
        [5, 4, 2, 0],
      ],
    ],
    [
      8,
      [
        [0, 2, 2, 1],
        [4, 3, 2, 1],
        [2, 1, 2, 0],
        [3, 1, 3, 0],
        [5, 4, 2, 0],
        [1, 3, 3, 0],
        [3, 4, 2, 1],
      ],
    ],
    [
      8,
      [
        [1, 2, 2, 1],
        [1, 3, 2, 1],
        [3, 4, 2, 1],
        [4, 1, 3, 0],
        [3, 1, 2, 0],
        [0, 1, 2, 0],
        [2, 4, 2, 0],
      ],
    ],
    [
      9,
      [
        [2, 2, 2, 1],
        [3, 3, 3, 0],
        [4, 5, 2, 1],
        [5, 2, 2, 0],
        [2, 4, 2, 0],
        [1, 1, 2, 0],
        [4, 2, 3, 0],
      ],
    ],
    [
      9,
      [
        [1, 2, 2, 1],
        [3, 4, 3, 1],
        [1, 3, 2, 0],
        [2, 3, 2, 0],
        [2, 0, 2, 1],
        [4, 1, 3, 0],
        [3, 5, 2, 1],
      ],
    ],
    [
      10,
      [
        [0, 2, 2, 1],
        [2, 4, 3, 1],
        [1, 0, 2, 0],
        [2, 0, 3, 0],
        [2, 3, 3, 1],
        [5, 1, 3, 0],
        [0, 4, 2, 1],
      ],
    ],
    [
      10,
      [
        [0, 2, 2, 1],
        [4, 0, 3, 0],
        [4, 4, 2, 1],
        [1, 0, 3, 1],
        [5, 0, 2, 0],
        [2, 1, 2, 0],
        [2, 3, 2, 0],
      ],
    ],
    [
      13,
      [
        [0, 2, 2, 1],
        [0, 3, 2, 0],
        [1, 4, 2, 1],
        [2, 1, 3, 0],
        [3, 3, 2, 0],
        [3, 1, 2, 0],
        [5, 2, 3, 0],
      ],
    ],
    [
      16,
      [
        [1, 2, 2, 1],
        [3, 1, 3, 0],
        [0, 3, 2, 1],
        [1, 4, 2, 0],
        [4, 1, 3, 0],
        [2, 5, 2, 1],
        [2, 3, 2, 0],
      ],
    ],
  ],
  7: [
    [
      6,
      [
        [2, 2, 2, 1],
        [3, 3, 2, 0],
        [4, 5, 2, 1],
        [4, 0, 2, 1],
        [5, 2, 2, 0],
        [0, 3, 3, 1],
        [3, 0, 2, 0],
        [4, 4, 2, 1],
      ],
    ],
    [
      7,
      [
        [0, 2, 2, 1],
        [1, 3, 3, 1],
        [1, 0, 2, 0],
        [3, 0, 3, 0],
        [0, 3, 2, 0],
        [0, 5, 2, 1],
        [3, 5, 2, 1],
        [2, 4, 2, 1],
      ],
    ],
    [
      7,
      [
        [1, 2, 2, 1],
        [0, 3, 2, 0],
        [2, 0, 2, 0],
        [2, 5, 2, 1],
        [3, 1, 3, 0],
        [3, 0, 3, 1],
        [5, 1, 2, 0],
        [4, 3, 2, 1],
      ],
    ],
    [
      8,
      [
        [2, 2, 2, 1],
        [5, 0, 3, 0],
        [4, 4, 2, 1],
        [3, 3, 2, 0],
        [4, 5, 2, 1],
        [1, 1, 2, 0],
        [4, 3, 2, 1],
        [0, 2, 3, 0],
      ],
    ],
    [
      8,
      [
        [0, 2, 2, 1],
        [3, 1, 3, 0],
        [4, 3, 2, 1],
        [2, 2, 3, 0],
        [1, 0, 2, 0],
        [0, 3, 3, 0],
        [3, 5, 2, 1],
        [5, 4, 2, 0],
      ],
    ],
    [
      9,
      [
        [2, 2, 2, 1],
        [4, 0, 3, 0],
        [4, 3, 2, 1],
        [2, 1, 2, 1],
        [0, 0, 2, 0],
        [3, 3, 3, 0],
        [4, 4, 2, 1],
        [2, 0, 2, 1],
      ],
    ],
    [
      9,
      [
        [1, 2, 2, 1],
        [3, 0, 3, 1],
        [2, 0, 2, 0],
        [1, 3, 2, 0],
        [4, 3, 2, 0],
        [3, 1, 3, 0],
        [0, 0, 3, 0],
        [2, 4, 2, 1],
      ],
    ],
    [
      10,
      [
        [2, 2, 2, 1],
        [4, 3, 2, 0],
        [4, 1, 2, 0],
        [1, 3, 3, 1],
        [1, 0, 3, 0],
        [4, 0, 2, 1],
        [1, 4, 2, 1],
        [3, 0, 2, 0],
      ],
    ],
    [
      10,
      [
        [2, 2, 2, 1],
        [4, 3, 2, 1],
        [0, 1, 3, 0],
        [3, 3, 3, 0],
        [2, 0, 2, 1],
        [4, 0, 3, 0],
        [1, 1, 3, 1],
        [2, 3, 2, 0],
      ],
    ],
    [
      11,
      [
        [0, 2, 2, 1],
        [3, 1, 3, 0],
        [2, 1, 2, 0],
        [5, 1, 2, 0],
        [1, 4, 2, 0],
        [2, 3, 2, 0],
        [0, 3, 2, 1],
        [2, 5, 3, 1],
      ],
    ],
    [
      11,
      [
        [1, 2, 2, 1],
        [0, 3, 2, 1],
        [2, 5, 2, 1],
        [0, 0, 3, 1],
        [2, 3, 2, 0],
        [0, 4, 2, 0],
        [3, 0, 3, 0],
        [3, 4, 3, 1],
      ],
    ],
    [
      13,
      [
        [0, 2, 2, 1],
        [3, 1, 3, 0],
        [3, 4, 2, 1],
        [4, 2, 2, 0],
        [5, 2, 3, 0],
        [0, 0, 2, 0],
        [1, 3, 2, 0],
        [2, 1, 2, 0],
      ],
    ],
    [
      14,
      [
        [0, 2, 2, 1],
        [5, 3, 2, 0],
        [3, 0, 2, 0],
        [2, 0, 3, 0],
        [5, 1, 2, 0],
        [4, 0, 2, 1],
        [2, 4, 3, 1],
        [4, 1, 2, 0],
      ],
    ],
    [
      16,
      [
        [1, 2, 2, 1],
        [3, 1, 3, 0],
        [4, 0, 3, 0],
        [3, 4, 2, 1],
        [0, 0, 2, 1],
        [0, 2, 2, 0],
        [1, 3, 2, 0],
        [2, 0, 2, 0],
      ],
    ],
  ],
  8: [
    [
      11,
      [
        [1, 2, 2, 1],
        [3, 4, 2, 1],
        [3, 3, 3, 1],
        [1, 3, 2, 0],
        [1, 5, 2, 1],
        [3, 0, 3, 0],
        [5, 4, 2, 0],
        [4, 0, 2, 1],
        [0, 2, 2, 0],
      ],
    ],
    [
      12,
      [
        [0, 2, 2, 1],
        [2, 1, 3, 0],
        [1, 4, 2, 1],
        [3, 1, 2, 1],
        [3, 4, 2, 0],
        [4, 4, 2, 1],
        [2, 0, 3, 1],
        [3, 3, 3, 1],
        [0, 5, 3, 1],
      ],
    ],
    [
      12,
      [
        [0, 2, 2, 1],
        [4, 1, 2, 0],
        [3, 3, 2, 0],
        [5, 4, 2, 0],
        [4, 3, 2, 1],
        [2, 5, 3, 1],
        [3, 1, 2, 0],
        [1, 4, 2, 0],
        [2, 2, 3, 0],
      ],
    ],
    [
      13,
      [
        [1, 2, 2, 1],
        [1, 3, 3, 1],
        [3, 0, 2, 1],
        [2, 4, 2, 0],
        [0, 2, 2, 0],
        [0, 0, 2, 0],
        [3, 4, 2, 1],
        [4, 1, 3, 0],
        [5, 1, 2, 0],
      ],
    ],
    [
      13,
      [
        [0, 2, 2, 1],
        [3, 2, 2, 0],
        [0, 3, 2, 0],
        [3, 4, 2, 0],
        [2, 1, 3, 0],
        [1, 4, 2, 1],
        [3, 1, 2, 1],
        [1, 5, 2, 1],
        [4, 3, 2, 0],
      ],
    ],
    [
      14,
      [
        [0, 2, 2, 1],
        [3, 4, 2, 0],
        [3, 1, 2, 1],
        [5, 2, 2, 0],
        [1, 0, 2, 0],
        [1, 4, 2, 1],
        [0, 3, 2, 0],
        [3, 2, 2, 0],
        [2, 1, 3, 0],
      ],
    ],
    [
      14,
      [
        [2, 2, 2, 1],
        [2, 3, 2, 0],
        [4, 1, 3, 0],
        [4, 4, 2, 1],
        [2, 1, 2, 1],
        [1, 2, 3, 0],
        [1, 0, 2, 1],
        [0, 5, 3, 1],
        [3, 4, 2, 0],
      ],
    ],
    [
      15,
      [
        [1, 2, 2, 1],
        [3, 1, 3, 0],
        [3, 4, 2, 1],
        [4, 2, 2, 0],
        [2, 5, 2, 1],
        [0, 0, 2, 0],
        [1, 0, 2, 1],
        [5, 2, 3, 0],
        [1, 4, 2, 0],
      ],
    ],
    [
      15,
      [
        [0, 2, 2, 1],
        [2, 1, 2, 0],
        [4, 0, 2, 0],
        [2, 3, 2, 0],
        [3, 4, 2, 1],
        [1, 0, 3, 1],
        [2, 5, 3, 1],
        [0, 4, 2, 0],
        [0, 3, 2, 1],
      ],
    ],
    [
      16,
      [
        [0, 2, 2, 1],
        [2, 0, 2, 0],
        [0, 3, 3, 1],
        [4, 1, 3, 0],
        [0, 0, 2, 0],
        [5, 1, 2, 0],
        [3, 0, 2, 1],
        [1, 4, 2, 0],
        [2, 5, 3, 1],
      ],
    ],
    [
      16,
      [
        [1, 2, 2, 1],
        [0, 5, 3, 1],
        [2, 0, 2, 0],
        [0, 1, 3, 0],
        [3, 0, 3, 0],
        [4, 0, 2, 1],
        [0, 4, 2, 1],
        [4, 3, 2, 0],
        [2, 4, 2, 1],
      ],
    ],
    [
      17,
      [
        [2, 2, 2, 1],
        [4, 5, 2, 1],
        [5, 1, 3, 0],
        [3, 3, 3, 0],
        [2, 3, 2, 0],
        [1, 4, 2, 0],
        [4, 1, 2, 0],
        [0, 3, 2, 1],
        [0, 0, 3, 0],
      ],
    ],
    [
      17,
      [
        [1, 2, 2, 1],
        [2, 1, 2, 1],
        [3, 4, 3, 1],
        [1, 0, 2, 0],
        [2, 3, 3, 0],
        [5, 1, 2, 0],
        [4, 3, 2, 1],
        [3, 2, 2, 0],
        [3, 5, 2, 1],
      ],
    ],
    [
      21,
      [
        [1, 2, 2, 1],
        [5, 0, 2, 0],
        [1, 0, 3, 1],
        [3, 4, 3, 1],
        [0, 3, 2, 1],
        [0, 5, 2, 1],
        [3, 1, 3, 0],
        [0, 0, 3, 0],
        [2, 4, 2, 0],
      ],
    ],
  ],
  9: [
    [
      13,
      [
        [0, 2, 2, 1],
        [1, 5, 3, 1],
        [3, 3, 2, 1],
        [3, 0, 2, 0],
        [2, 1, 3, 0],
        [2, 4, 2, 1],
        [4, 4, 2, 0],
        [0, 0, 2, 0],
        [1, 0, 2, 1],
        [1, 3, 2, 0],
      ],
    ],
    [
      13,
      [
        [1, 2, 2, 1],
        [4, 4, 2, 1],
        [4, 1, 3, 0],
        [1, 0, 2, 0],
        [3, 3, 2, 0],
        [2, 4, 2, 0],
        [0, 5, 2, 1],
        [0, 2, 3, 0],
        [2, 1, 2, 1],
        [2, 0, 2, 1],
      ],
    ],
    [
      14,
      [
        [1, 2, 2, 1],
        [3, 5, 2, 1],
        [2, 0, 2, 1],
        [2, 4, 2, 0],
        [1, 3, 2, 1],
        [3, 4, 3, 1],
        [3, 1, 3, 0],
        [5, 2, 2, 0],
        [0, 1, 2, 0],
        [0, 3, 2, 0],
      ],
    ],
    [
      14,
      [
        [0, 2, 2, 1],
        [4, 0, 2, 0],
        [3, 4, 2, 1],
        [1, 3, 3, 0],
        [2, 3, 2, 0],
        [2, 1, 2, 0],
        [2, 0, 2, 1],
        [3, 5, 2, 1],
        [3, 1, 3, 0],
        [0, 0, 2, 0],
      ],
    ],
    [
      15,
      [
        [1, 2, 2, 1],
        [2, 5, 3, 1],
        [0, 0, 3, 0],
        [4, 1, 2, 1],
        [1, 4, 2, 0],
        [2, 4, 2, 1],
        [5, 3, 2, 0],
        [3, 1, 3, 0],
        [4, 3, 2, 0],
        [2, 0, 2, 0],
      ],
    ],
    [
      16,
      [
        [0, 2, 2, 1],
        [2, 0, 2, 1],
        [2, 2, 2, 0],
        [1, 0, 2, 0],
        [4, 0, 2, 1],
        [4, 2, 3, 0],
        [1, 4, 3, 1],
        [5, 3, 2, 0],
        [0, 3, 3, 0],
        [3, 5, 2, 1],
      ],
    ],
    [
      16,
      [
        [0, 2, 2, 1],
        [5, 4, 2, 0],
        [3, 4, 2, 0],
        [1, 0, 3, 1],
        [4, 0, 2, 1],
        [1, 5, 2, 1],
        [2, 1, 3, 0],
        [0, 0, 2, 0],
        [3, 3, 2, 1],
        [0, 4, 3, 1],
      ],
    ],
    [
      17,
      [
        [0, 2, 2, 1],
        [1, 0, 2, 0],
        [2, 0, 2, 0],
        [1, 4, 3, 1],
        [0, 3, 3, 0],
        [4, 3, 2, 0],
        [3, 1, 2, 1],
        [2, 2, 2, 0],
        [3, 0, 2, 1],
        [3, 2, 2, 0],
      ],
    ],
    [
      17,
      [
        [2, 2, 2, 1],
        [1, 0, 2, 1],
        [4, 0, 2, 0],
        [1, 2, 2, 0],
        [0, 3, 2, 0],
        [3, 0, 2, 0],
        [3, 3, 2, 0],
        [4, 5, 2, 1],
        [5, 0, 3, 0],
        [4, 4, 2, 1],
      ],
    ],
    [
      18,
      [
        [0, 2, 2, 1],
        [3, 2, 3, 0],
        [0, 0, 3, 1],
        [4, 3, 2, 0],
        [3, 1, 2, 1],
        [0, 4, 2, 0],
        [2, 1, 3, 0],
        [5, 2, 3, 0],
        [1, 4, 2, 1],
        [1, 5, 2, 1],
      ],
    ],
    [
      19,
      [
        [1, 2, 2, 1],
        [1, 4, 2, 0],
        [5, 1, 2, 0],
        [0, 3, 2, 1],
        [3, 2, 2, 0],
        [2, 3, 3, 0],
        [4, 1, 2, 0],
        [3, 0, 2, 0],
        [3, 4, 2, 1],
        [5, 3, 2, 0],
      ],
    ],
    [
      20,
      [
        [0, 2, 2, 1],
        [2, 4, 2, 1],
        [2, 0, 3, 0],
        [3, 0, 2, 0],
        [1, 3, 2, 0],
        [5, 2, 2, 0],
        [4, 0, 2, 1],
        [4, 1, 2, 0],
        [1, 5, 2, 1],
        [4, 3, 2, 0],
      ],
    ],
    [
      21,
      [
        [0, 2, 2, 1],
        [3, 3, 2, 0],
        [3, 1, 2, 0],
        [1, 3, 2, 1],
        [3, 0, 2, 1],
        [0, 3, 2, 0],
        [5, 2, 3, 0],
        [2, 0, 3, 0],
        [1, 4, 2, 1],
        [4, 2, 2, 0],
      ],
    ],
    [
      21,
      [
        [1, 2, 2, 1],
        [2, 3, 2, 0],
        [1, 4, 2, 0],
        [1, 1, 2, 1],
        [3, 1, 3, 0],
        [0, 1, 2, 0],
        [4, 1, 2, 0],
        [0, 3, 2, 1],
        [4, 5, 2, 1],
        [2, 5, 2, 1],
      ],
    ],
  ],
  10: [
    [
      15,
      [
        [0, 2, 2, 1],
        [2, 1, 3, 0],
        [2, 4, 2, 1],
        [0, 3, 3, 0],
        [4, 5, 2, 1],
        [4, 3, 2, 0],
        [0, 0, 2, 0],
        [3, 1, 2, 0],
        [5, 2, 3, 0],
        [1, 0, 2, 0],
        [3, 0, 2, 1],
      ],
    ],
    [
      15,
      [
        [0, 2, 2, 1],
        [2, 0, 2, 1],
        [1, 0, 2, 0],
        [4, 4, 2, 1],
        [4, 0, 2, 0],
        [2, 1, 2, 0],
        [3, 1, 2, 0],
        [3, 4, 2, 0],
        [5, 0, 2, 0],
        [2, 3, 2, 0],
        [3, 3, 2, 1],
      ],
    ],
    [
      16,
      [
        [0, 2, 2, 1],
        [4, 2, 3, 0],
        [3, 5, 2, 1],
        [2, 4, 2, 1],
        [0, 0, 2, 0],
        [3, 1, 2, 1],
        [2, 1, 2, 0],
        [3, 0, 2, 1],
        [1, 0, 2, 1],
        [1, 3, 2, 0],
        [5, 2, 2, 0],
      ],
    ],
    [
      16,
      [
        [0, 2, 2, 1],
        [2, 2, 3, 0],
        [4, 4, 2, 0],
        [0, 3, 2, 0],
        [2, 0, 2, 1],
        [0, 5, 3, 1],
        [1, 0, 2, 0],
        [2, 1, 2, 1],
        [3, 3, 2, 1],
        [5, 3, 3, 0],
        [5, 1, 2, 0],
      ],
    ],
    [
      17,
      [
        [0, 2, 2, 1],
        [3, 3, 2, 0],
        [4, 4, 2, 0],
        [4, 3, 2, 1],
        [0, 0, 2, 1],
        [1, 1, 2, 1],
        [5, 0, 3, 0],
        [2, 0, 3, 1],
        [1, 5, 3, 1],
        [3, 1, 2, 1],
        [2, 2, 3, 0],
      ],
    ],
    [
      17,
      [
        [0, 2, 2, 1],
        [3, 0, 3, 1],
        [5, 2, 3, 0],
        [4, 2, 2, 0],
        [1, 3, 2, 0],
        [2, 1, 2, 1],
        [2, 2, 2, 0],
        [0, 0, 2, 0],
        [2, 4, 3, 1],
        [1, 0, 2, 1],
        [4, 1, 2, 1],
      ],
    ],
    [
      18,
      [
        [1, 2, 2, 1],
        [3, 1, 2, 0],
        [2, 3, 2, 1],
        [0, 5, 2, 1],
        [2, 4, 2, 0],
        [4, 0, 2, 0],
        [3, 4, 2, 1],
        [4, 2, 2, 0],
        [0, 2, 2, 0],
        [1, 3, 2, 0],
        [1, 0, 2, 1],
      ],
    ],
    [
      18,
      [
        [1, 2, 2, 1],
        [1, 0, 2, 0],
        [3, 0, 2, 1],
        [0, 3, 2, 1],
        [3, 1, 3, 0],
        [5, 0, 2, 0],
        [2, 3, 2, 0],
        [3, 5, 2, 1],
        [0, 0, 3, 0],
        [4, 2, 2, 0],
        [3, 4, 3, 1],
      ],
    ],
    [
      19,
      [
        [0, 2, 2, 1],
        [0, 0, 2, 0],
        [5, 0, 3, 0],
        [3, 0, 2, 1],
        [4, 3, 2, 1],
        [2, 2, 2, 0],
        [1, 0, 2, 1],
        [4, 4, 2, 0],
        [1, 3, 2, 0],
        [2, 4, 2, 1],
        [3, 2, 2, 0],
      ],
    ],
    [
      19,
      [
        [0, 2, 2, 1],
        [1, 3, 2, 0],
        [5, 3, 3, 0],
        [2, 2, 3, 0],
        [4, 0, 2, 1],
        [0, 0, 2, 0],
        [5, 1, 2, 0],
        [2, 0, 2, 0],
        [2, 5, 3, 1],
        [3, 0, 2, 0],
        [3, 2, 2, 0],
      ],
    ],
    [
      20,
      [
        [1, 2, 2, 1],
        [2, 3, 2, 1],
        [3, 4, 3, 1],
        [0, 5, 2, 1],
        [1, 3, 2, 0],
        [4, 0, 2, 0],
        [1, 0, 2, 1],
        [3, 1, 2, 0],
        [2, 4, 2, 0],
        [4, 2, 2, 0],
        [5, 1, 2, 0],
      ],
    ],
    [
      20,
      [
        [0, 2, 2, 1],
        [4, 2, 3, 0],
        [1, 4, 3, 1],
        [0, 0, 2, 0],
        [3, 0, 2, 1],
        [1, 3, 2, 1],
        [5, 3, 2, 0],
        [1, 0, 2, 1],
        [3, 2, 2, 0],
        [2, 1, 2, 0],
        [2, 5, 2, 1],
      ],
    ],
    [
      22,
      [
        [0, 2, 2, 1],
        [0, 0, 2, 0],
        [4, 0, 2, 0],
        [5, 4, 2, 0],
        [1, 5, 2, 1],
        [3, 1, 3, 0],
        [2, 1, 2, 0],
        [1, 0, 3, 1],
        [2, 3, 2, 0],
        [4, 3, 2, 1],
        [5, 0, 2, 0],
      ],
    ],
    [
      22,
      [
        [1, 2, 2, 1],
        [0, 0, 2, 1],
        [1, 4, 2, 0],
        [5, 2, 2, 0],
        [3, 4, 2, 1],
        [2, 0, 2, 0],
        [3, 5, 2, 1],
        [0, 2, 2, 0],
        [2, 3, 2, 0],
        [4, 0, 3, 0],
        [3, 1, 3, 0],
      ],
    ],
  ],
  11: [
    [
      16,
      [
        [2, 2, 2, 1],
        [2, 3, 3, 1],
        [4, 4, 2, 1],
        [1, 2, 2, 0],
        [4, 1, 2, 1],
        [5, 2, 2, 0],
        [0, 3, 2, 0],
        [0, 5, 2, 1],
        [3, 4, 2, 0],
        [1, 0, 2, 1],
        [0, 1, 2, 0],
        [3, 0, 2, 0],
      ],
    ],
    [
      17,
      [
        [0, 2, 2, 1],
        [1, 5, 3, 1],
        [0, 0, 2, 0],
        [1, 0, 2, 1],
        [2, 1, 2, 0],
        [0, 4, 3, 1],
        [3, 4, 2, 1],
        [3, 0, 2, 0],
        [0, 3, 2, 1],
        [5, 1, 2, 0],
        [4, 5, 2, 1],
        [4, 0, 2, 0],
      ],
    ],
    [
      17,
      [
        [0, 2, 2, 1],
        [0, 3, 2, 0],
        [2, 1, 2, 0],
        [2, 0, 3, 1],
        [2, 4, 2, 1],
        [5, 0, 2, 0],
        [4, 1, 2, 0],
        [5, 2, 2, 0],
        [1, 5, 3, 1],
        [4, 4, 2, 1],
        [3, 3, 2, 1],
        [1, 0, 2, 0],
      ],
    ],
    [
      18,
      [
        [2, 2, 2, 1],
        [2, 0, 2, 0],
        [0, 3, 2, 0],
        [1, 4, 2, 0],
        [3, 3, 2, 1],
        [1, 3, 2, 1],
        [4, 5, 2, 1],
        [0, 1, 2, 1],
        [5, 1, 3, 0],
        [4, 0, 2, 1],
        [2, 5, 2, 1],
        [4, 4, 2, 1],
      ],
    ],
    [
      18,
      [
        [2, 2, 2, 1],
        [1, 0, 3, 0],
        [1, 3, 2, 1],
        [0, 5, 2, 1],
        [2, 0, 2, 0],
        [3, 0, 2, 0],
        [3, 3, 2, 1],
        [5, 2, 2, 0],
        [5, 4, 2, 0],
        [4, 0, 2, 1],
        [0, 2, 2, 0],
        [2, 4, 2, 0],
      ],
    ],
    [
      19,
      [
        [0, 2, 2, 1],
        [2, 2, 2, 0],
        [3, 5, 2, 1],
        [1, 0, 2, 0],
        [1, 4, 2, 1],
        [0, 3, 2, 0],
        [2, 0, 3, 1],
        [2, 1, 2, 1],
        [5, 2, 2, 0],
        [4, 1, 2, 0],
        [3, 2, 2, 0],
        [4, 3, 2, 0],
      ],
    ],
    [
      19,
      [
        [0, 2, 2, 1],
        [2, 5, 2, 1],
        [4, 3, 2, 1],
        [5, 0, 3, 0],
        [2, 0, 3, 1],
        [0, 3, 2, 0],
        [2, 1, 3, 1],
        [1, 0, 2, 0],
        [2, 4, 3, 1],
        [2, 2, 2, 0],
        [4, 5, 2, 1],
        [3, 2, 2, 0],
      ],
    ],
    [
      20,
      [
        [0, 2, 2, 1],
        [4, 3, 2, 1],
        [1, 4, 2, 1],
        [1, 5, 3, 1],
        [2, 1, 2, 1],
        [0, 3, 3, 0],
        [3, 2, 3, 0],
        [5, 4, 2, 0],
        [0, 0, 2, 0],
        [4, 1, 2, 0],
        [2, 2, 2, 0],
        [1, 0, 3, 1],
      ],
    ],
    [
      20,
      [
        [0, 2, 2, 1],
        [4, 3, 2, 0],
        [3, 1, 2, 1],
        [0, 1, 3, 1],
        [0, 0, 3, 1],
        [2, 2, 2, 0],
        [3, 3, 2, 0],
        [2, 5, 2, 1],
        [5, 2, 2, 0],
        [1, 4, 2, 1],
        [0, 4, 2, 0],
        [0, 3, 2, 1],
      ],
    ],
    [
      21,
      [
        [2, 2, 2, 1],
        [3, 4, 3, 1],
        [2, 5, 3, 1],
        [1, 0, 2, 1],
        [1, 1, 2, 0],
        [2, 3, 2, 0],
        [0, 3, 2, 1],
        [0, 4, 2, 0],
        [0, 1, 2, 0],
        [4, 0, 3, 0],
        [3, 0, 2, 0],
        [5, 0, 3, 0],
      ],
    ],
    [
      23,
      [
        [0, 2, 2, 1],
        [4, 3, 2, 1],
        [5, 4, 2, 0],
        [1, 3, 2, 0],
        [3, 1, 2, 1],
        [2, 1, 3, 0],
        [0, 5, 2, 1],
        [4, 4, 2, 0],
        [2, 5, 2, 1],
        [3, 2, 2, 0],
        [1, 0, 2, 1],
        [2, 4, 2, 1],
      ],
    ],
    [
      23,
      [
        [0, 2, 2, 1],
        [0, 4, 3, 1],
        [3, 2, 3, 0],
        [1, 0, 2, 1],
        [4, 3, 2, 0],
        [0, 3, 2, 1],
        [0, 0, 2, 0],
        [2, 1, 2, 1],
        [3, 5, 2, 1],
        [4, 1, 2, 1],
        [5, 3, 2, 0],
        [2, 2, 2, 0],
      ],
    ],
    [
      24,
      [
        [1, 2, 2, 1],
        [1, 0, 2, 0],
        [2, 0, 2, 0],
        [3, 4, 2, 1],
        [4, 0, 2, 1],
        [3, 0, 2, 0],
        [0, 2, 3, 0],
        [3, 2, 2, 0],
        [0, 5, 2, 1],
        [2, 4, 2, 0],
        [4, 3, 2, 1],
        [5, 4, 2, 0],
      ],
    ],
    [
      26,
      [
        [0, 2, 2, 1],
        [0, 3, 2, 0],
        [1, 4, 2, 1],
        [2, 0, 3, 1],
        [1, 1, 2, 1],
        [3, 4, 2, 1],
        [4, 1, 2, 0],
        [3, 2, 2, 0],
        [5, 0, 2, 0],
        [2, 2, 2, 0],
        [0, 5, 3, 1],
        [4, 3, 2, 1],
      ],
    ],
  ],
  12: [
    [
      17,
      [
        [0, 2, 2, 1],
        [1, 3, 2, 0],
        [2, 4, 2, 1],
        [4, 3, 2, 1],
        [2, 5, 2, 1],
        [0, 0, 2, 0],
        [1, 0, 2, 0],
        [2, 0, 3, 1],
        [3, 2, 2, 0],
        [5, 4, 2, 0],
        [4, 4, 2, 0],
        [0, 3, 3, 0],
        [2, 1, 3, 0],
      ],
    ],
    [
      18,
      [
        [0, 2, 2, 1],
        [0, 0, 2, 0],
        [1, 0, 2, 1],
        [4, 3, 2, 0],
        [1, 1, 2, 1],
        [3, 0, 3, 1],
        [0, 4, 3, 1],
        [3, 3, 2, 0],
        [4, 1, 2, 1],
        [2, 5, 2, 1],
        [5, 3, 2, 0],
        [0, 5, 2, 1],
        [2, 2, 2, 0],
      ],
    ],
    [
      18,
      [
        [0, 2, 2, 1],
        [3, 4, 2, 1],
        [2, 0, 3, 1],
        [1, 3, 2, 0],
        [3, 2, 2, 0],
        [3, 1, 2, 1],
        [0, 5, 2, 1],
        [2, 1, 2, 0],
        [2, 4, 2, 0],
        [4, 3, 2, 1],
        [0, 3, 2, 0],
        [5, 4, 2, 0],
        [1, 0, 2, 0],
      ],
    ],
    [
      19,
      [
        [0, 2, 2, 1],
        [1, 0, 2, 0],
        [1, 4, 2, 1],
        [2, 0, 2, 1],
        [4, 1, 2, 1],
        [4, 0, 2, 1],
        [5, 4, 2, 0],
        [0, 3, 2, 0],
        [4, 3, 2, 0],
        [2, 5, 3, 1],
        [5, 2, 2, 0],
        [3, 3, 2, 0],
        [2, 2, 2, 0],
      ],
    ],
    [
      19,
      [
        [2, 2, 2, 1],
        [0, 5, 2, 1],
        [5, 1, 2, 0],
        [3, 4, 2, 0],
        [4, 2, 2, 0],
        [1, 2, 2, 0],
        [0, 0, 2, 1],
        [2, 4, 2, 0],
        [3, 1, 2, 1],
        [2, 3, 2, 1],
        [4, 4, 2, 1],
        [2, 0, 2, 0],
        [0, 2, 2, 0],
      ],
    ],
    [
      20,
      [
        [0, 2, 2, 1],
        [1, 0, 2, 0],
        [2, 1, 2, 1],
        [3, 3, 2, 0],
        [2, 2, 2, 0],
        [4, 0, 2, 1],
        [4, 1, 2, 1],
        [5, 4, 2, 0],
        [5, 2, 2, 0],
        [4, 3, 2, 0],
        [0, 3, 2, 0],
        [1, 4, 2, 1],
        [2, 0, 2, 1],
      ],
    ],
    [
      21,
      [
        [0, 2, 2, 1],
        [3, 1, 3, 0],
        [1, 5, 2, 1],
        [0, 4, 2, 0],
        [4, 3, 2, 1],
        [2, 1, 2, 0],
        [2, 3, 2, 0],
        [3, 5, 2, 1],
        [0, 0, 2, 0],
        [4, 0, 2, 0],
        [5, 4, 2, 0],
        [1, 3, 2, 0],
        [2, 0, 2, 1],
      ],
    ],
    [
      22,
      [
        [0, 2, 2, 1],
        [0, 3, 2, 1],
        [4, 2, 2, 0],
        [3, 0, 2, 1],
        [2, 3, 2, 0],
        [3, 4, 2, 0],
        [0, 0, 2, 0],
        [5, 3, 2, 0],
        [3, 2, 2, 0],
        [1, 0, 2, 0],
        [5, 1, 2, 0],
        [2, 1, 2, 0],
        [3, 1, 2, 1],
      ],
    ],
    [
      22,
      [
        [0, 2, 2, 1],
        [1, 0, 2, 0],
        [5, 0, 2, 0],
        [4, 5, 2, 1],
        [3, 4, 2, 0],
        [2, 1, 3, 0],
        [3, 3, 2, 1],
        [0, 4, 2, 0],
        [1, 4, 2, 1],
        [4, 0, 2, 0],
        [5, 2, 3, 0],
        [2, 0, 2, 1],
        [1, 5, 2, 1],
      ],
    ],
    [
      24,
      [
        [0, 2, 2, 1],
        [5, 4, 2, 0],
        [4, 0, 2, 1],
        [2, 1, 2, 0],
        [3, 4, 2, 0],
        [3, 3, 2, 1],
        [1, 4, 2, 1],
        [1, 3, 2, 1],
        [5, 2, 2, 0],
        [2, 0, 2, 1],
        [1, 0, 2, 0],
        [3, 1, 3, 1],
        [0, 3, 2, 0],
      ],
    ],
    [
      26,
      [
        [1, 2, 2, 1],
        [1, 0, 2, 0],
        [4, 5, 2, 1],
        [3, 1, 2, 0],
        [3, 3, 2, 1],
        [0, 1, 2, 0],
        [5, 2, 3, 0],
        [4, 0, 2, 1],
        [0, 4, 2, 0],
        [2, 0, 2, 1],
        [3, 4, 2, 1],
        [2, 3, 2, 0],
        [1, 5, 3, 1],
      ],
    ],
    [
      28,
      [
        [1, 2, 2, 1],
        [3, 2, 2, 0],
        [2, 4, 2, 1],
        [1, 3, 2, 1],
        [5, 3, 2, 0],
        [2, 0, 2, 0],
        [4, 0, 2, 1],
        [0, 5, 2, 1],
        [0, 1, 2, 0],
        [2, 5, 3, 1],
        [5, 1, 2, 0],
        [0, 3, 2, 0],
        [3, 0, 2, 0],
      ],
    ],
    [
      30,
      [
        [0, 2, 2, 1],
        [4, 3, 2, 1],
        [1, 3, 2, 0],
        [4, 1, 2, 1],
        [1, 0, 3, 1],
        [2, 2, 2, 0],
        [4, 0, 2, 1],
        [3, 1, 3, 0],
        [3, 5, 2, 1],
        [0, 0, 2, 0],
        [0, 5, 2, 1],
        [2, 4, 2, 1],
        [5, 4, 2, 0],
      ],
    ],
    [
      32,
      [
        [0, 2, 2, 1],
        [1, 0, 2, 1],
        [3, 0, 2, 1],
        [3, 4, 2, 1],
        [3, 1, 3, 0],
        [2, 2, 3, 0],
        [1, 5, 2, 1],
        [1, 3, 2, 0],
        [0, 0, 2, 0],
        [4, 3, 2, 1],
        [4, 1, 2, 1],
        [3, 5, 2, 1],
        [5, 4, 2, 0],
      ],
    ],
  ],
};
